import {
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { IValidationRule } from "../IValidationRule";
import { ValidationMessageRowComponent, ValidationMessageType } from "../validation-message-row/validation-message-row.component";
import { RuleContainer } from "../validation.service";

@Component({
    selector: "rask-validation-message-container",
    templateUrl: "./validation-message-container.component.html",
    styleUrls: ["./validation-message-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ValidationMessageRowComponent]
})
export class ValidationMessageContainerComponent implements OnInit, OnDestroy {
    dynamic = false;
    @Input() id;
    rules: IValidationRule[] = [];

    private readonly elementRef = inject(ElementRef);

    // eslint-disable-next-line sonarjs/public-static-readonly
    static StaticContainers: ValidationMessageContainerComponent[] = [];

    get elementPosY() {
        return this.elementRef.nativeElement.offsetTop;
    }

    addNonExistingRule(rule: IValidationRule, containers: RuleContainer[], element: HTMLElement): void {
        const existingRuleIndex = this.rules?.findIndex(x => x.message?.text === rule.message?.text);
        if (existingRuleIndex === -1) {
            this.rules.push(rule);
            containers.push({
                rule: rule,
                container: this,
                element: element
            });
        }
    }

    getRuleType(rule: IValidationRule): ValidationMessageType {
        return rule.hasWarning ? "warning" : "error";
    }

    invalid(rule: IValidationRule): boolean {
        return rule.hasError || rule.hasWarning;
    }

    ngOnDestroy(): void {
        if (!this.dynamic) {
            const index = ValidationMessageContainerComponent.StaticContainers.indexOf(this);
            ValidationMessageContainerComponent.StaticContainers.splice(index, 1);
        }
    }

    ngOnInit(): void {
        if (!this.dynamic) {
            ValidationMessageContainerComponent.StaticContainers.push(this);
        }
    }
}
